import script from "./AppDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDialog.vue?vue&type=script&setup=true&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=17e5e31c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17e5e31c"]])

export default __exports__